import {
  getStreetsBySectionId,
  createStreet,
  updateStreet,
  deleteStreet,
} from "../../../api/streets/streetRequest";
import { useEntityManagement } from "../../../hooks/useEntityManagement";

export const useStreetManagement = (sectionId, form) => {
  const sectionManagement = useEntityManagement(form, {
    entityName: "Rue",
    api: {
      getEntities: () => getStreetsBySectionId(sectionId),
      createEntity: (value) =>
        createStreet({ ...value, section_id: sectionId }),
      updateEntity: updateStreet,
      deleteEntity: deleteStreet,
    },
  });

  return {
    ...sectionManagement,
  };
};
